import * as React from 'react'

import {
  Sheet,
  SheetCloseButton,
  SheetContent,
  SheetOverlay,
  SheetTitle,
} from '@wartek-id/sheet'
import { Button } from '@wartek-id/button'

import { Listbox } from 'components/Listbox'

import type { PacketFilterKeys } from 'types/assessment'

interface SheetSelectPhaseProps {
  isOpen: boolean
  onClose: React.Dispatch<React.SetStateAction<boolean>>
  selectedPhase: string
  phases: string[]
  setValue: (value: string, key: PacketFilterKeys) => void
}
const SheetSelectPhase = ({
  isOpen,
  onClose,
  phases,
  selectedPhase,
  setValue,
}: SheetSelectPhaseProps) => {
  const [selectedList, setSelectedList] = React.useState<string>('')

  React.useEffect(() => {
    setSelectedList(selectedPhase)
  }, [selectedPhase])

  return (
    <Sheet isOpen={isOpen} onClose={onClose} sheetSize="xl">
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto">
        <SheetTitle>Pilih Fase</SheetTitle>
        <div className="px-4 pb-16">
          <div className="w-full text-center px-8 mb-1 text-sm text-[#888D93]">
            Tips: Pilih fase dimana murid sudah pernah belajar sebelumnya
          </div>
          {phases.map((phase, idx) => (
            <Listbox
              key={idx}
              onClick={() => setSelectedList(phase)}
              selected={phase === selectedList}
            >
              {phase}
            </Listbox>
          ))}
          <div className="bg-white font-sem fixed w-full left-0 bottom-0 py-3 px-4">
            <Button
              color="orange"
              onClick={() => {
                onClose(false)
                setValue(selectedList, 'phase')
              }}
              fullWidth
            >
              Terapkan
            </Button>
          </div>
        </div>
        <SheetCloseButton />
      </SheetContent>
    </Sheet>
  )
}

export default SheetSelectPhase
